<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/property-setting' }">
        <app-i18n code="entities.propertySetting.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.propertySetting.importer.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.propertySetting.importer.title"></app-i18n>
      </h1>

      <app-importer storePath="propertySetting/importer"></app-importer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-property-setting-importer-page',
};
</script>

<style>
</style>
